import { FieldType } from '@/components/Form';
import { DatabaseField } from '@/modules/corporate/modules/database/fields/types';

import NumberFieldEditorConfig from './Editor/config';
import Cell from './Cell';
import { NumberFieldStaticConfig } from './config';
import EditableCell from './EditableCell';
import FilterInput from './FilterInput';
import NumberOperators from './operators';
import { adaptNumberField, isFormDataValid, parseFormData } from './utils';

const NumberField: DatabaseField = {
  ...NumberFieldStaticConfig,
  Table: {
    Cell,
    EditableCell,
    FilterInput,
    operators: NumberOperators,
  },
  Viewer: {
    parseFormData,
    isFormDataValid,
    fieldType: FieldType.Number,
    adaptFormField: NumberFieldEditorConfig.adaptEditorFormField,
  },
  Editor: NumberFieldEditorConfig,
  adaptField: adaptNumberField,
};

export default NumberField;
